export default __webpack_public_path__ + "static/media/toolbar-unordered.ea29d4f3.svg";